import React, { useMemo } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import useTranslation from '../../../Hooks/useTranslation'

const RetentionPeriodConfirmModal = ({
    open,
    upgradeItem,
    onClose,
    onConfirm,
    confirmLoading,
}) => {
    const translation = useTranslation()

    const modalCopy = useMemo(() => {
        if (!upgradeItem) return { title: '', body: '' }
        const nextPkg = upgradeItem.newPackage ?? upgradeItem.NewPackage ?? {}
        const newName = nextPkg.name ?? nextPkg.Name ?? ''
        const currentBillable =
            Number(
                upgradeItem.currentBillableUnits ??
                    upgradeItem.CurrentBillableUnits,
            ) || 0
        const nextBillable =
            Number(
                upgradeItem.newBillableUnits ?? upgradeItem.NewBillableUnits,
            ) || 0
        const title = translation.formatString(
            translation.subscriptionPackageUpgradeModalTitle,
            { packageName: newName },
        )
        const body = translation.formatString(
            translation.subscriptionPackageUpgradeModalBody,
            {
                currentBillableUnits: currentBillable,
                ordinalUnit: nextBillable,
                nextUnit: nextBillable,
            },
        )
        return { title, body }
    }, [upgradeItem, translation])

    const transitionLabels = useMemo(() => {
        if (!upgradeItem) return { from: '', to: '' }
        const current =
            upgradeItem.currentPackage ?? upgradeItem.CurrentPackage ?? {}
        const nextPkg = upgradeItem.newPackage ?? upgradeItem.NewPackage ?? {}
        return {
            from: current.name ?? current.Name ?? '',
            to: nextPkg.name ?? nextPkg.Name ?? '',
        }
    }, [upgradeItem])

    return (
        <Dialog
            open={open}
            onClose={(_, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    onClose()
                }
            }}
            className="respModal autoHeight subscriptionPackageUpgradeModal"
        >
            <div className="subscriptionPackageUpgradeModalHeader">
                <h1 className="modalTitle subscriptionPackageUpgradeModalTitle">
                    {modalCopy.title}
                </h1>
            </div>
            <p className="subscriptionPackageUpgradeModalBody">
                {modalCopy.body}
            </p>
            <div className="subscriptionPackageUpgradeArrowBox">
                <span className="subscriptionPackageUpgradeArrowFrom">
                    {transitionLabels.from}
                </span>
                <ArrowForwardIcon
                    className="subscriptionPackageUpgradeArrowIcon"
                    fontSize="small"
                />
                <span className="subscriptionPackageUpgradeArrowTo">
                    {transitionLabels.to}
                </span>
            </div>
            <div className="btnHolder end fixedWidthBtn subscriptionPackageUpgradeModalActions">
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onClose}
                    disabled={confirmLoading}
                >
                    {translation.cancelButtonLabel}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onConfirm}
                    disabled={confirmLoading}
                >
                    {translation.subscriptionPackageUpgradeModalConfirm}
                </Button>
            </div>
        </Dialog>
    )
}

export default RetentionPeriodConfirmModal
